// extracted by mini-css-extract-plugin
export default {"momentsCardReset":"progressTable_momentsCardReset__9vTe4","momentsContentReset":"progressTable_momentsContentReset__MIIKQ"};